// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header-module--headerContainer--3MF2m","header":"Header-module--header--2skx2","logoContainer":"Header-module--logoContainer--1YJbt"};